var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-04-10
 * @brief SEI Header 컴포넌트
 *
 ********************************************************************/
import { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useLocation, useNavigate } from "react-router-dom";
import $ from "jquery";
//recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { langId, langState } from "../../../recoil/langState";
import { headerAlarmState, headerSettingState, headerUserInfoState, loadingBoxState, menuListState, menuState, parentCode, urlState, } from "../../../recoil/menuState";
//
import { demo, userInfoLoginState, userInfoState } from "../../../recoil/userState";
//utils
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import * as i18n from "../../../utils/langs/i18nUtils";
import * as USERUTIL from "../../../utils/user/userUtils";
//
import SideBar from "@layout/header/dashBoard/SideBar";
import { handleClickOutside } from "@utils/ClickUtils";
import { adminTabState, alertState, energyTab, mainState, noneUrl } from "../../../recoil/assessmentState";
import { useTrans } from "../../../utils/langs/useTrans";
import AlarmCount from "./AlarmCount";
function DashBoardHeader() {
    // trans, navgate, ref
    const location = useLocation();
    const navigate = useNavigate();
    const t = useTrans();
    const mobileRef = useRef(null); // Mobile Check용
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilUserInfo = useSetRecoilState(userInfoState);
    const [hbMenuToggle, setRecoilHbMenuToggle] = useRecoilState(menuState);
    const [settingPopup, setRecoilSettingPopup] = useRecoilState(headerSettingState);
    const [alarmPopup, setRecoilAlarmPopup] = useRecoilState(headerAlarmState);
    const [userInfoPopup, setRecoilUserInfoPopup] = useRecoilState(headerUserInfoState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [recoilMenuCode, setRecoilMenuCode] = useRecoilState(parentCode);
    const menuRecoilList = useRecoilValue(menuListState);
    const [alarmCount, setAlarmCount] = useState(0); // 읽지 않은 alarm
    const [alarmCountReload, setAlarmCountReload] = useState(false);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    const setRecoilTab = useSetRecoilState(adminTabState);
    const [recoilLangs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    const setRecoilLangIds = useSetRecoilState(langId);
    const setRecoilEnergyTab = useSetRecoilState(energyTab);
    const [isWindow, setIsWindow] = useState(true);
    const [isPFMobile, setIsPFMobile] = useState(false);
    const [isPSMobile, setIsPSMobile] = useState(false);
    const demos = useRecoilValue(demo);
    useEffect(() => {
        const clickOutside = (e) => {
            handleClickOutside(e, setRecoilSettingPopup, setRecoilUserInfoPopup, setRecoilAlarmPopup);
        };
        document.addEventListener("click", clickOutside);
        return () => {
            document.removeEventListener("click", clickOutside);
        };
    }, []);
    useEffect(() => {
        // resize handler  // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if (!CUTIL.isnull(mobileTag)) {
                if (mobileTag.clientWidth <= 1500) {
                    setIsWindow(false);
                }
                else {
                    setIsWindow(true);
                }
                if (mobileTag.clientWidth <= 940) {
                    setIsPSMobile(true);
                }
                else {
                    setIsPSMobile(false);
                }
                if (mobileTag.clientWidth <= 758) {
                    setIsPFMobile(true);
                }
                else {
                    setIsPFMobile(false);
                }
            }
        }
        handleResize(); // init ismobile check
        window.addEventListener("resize", handleResize); // resize ismobile check
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const params = new URLSearchParams(location.search);
    const paramsLagns = params.get("lang");
    useEffect(() => {
        if (paramsLagns) {
            let lagn = CONST.STR_LANG_ENG;
            let boolean = false;
            exchgLanguage(lagn, boolean);
        }
    }, [paramsLagns]);
    function showRightSideBar() {
        $(".navbar__menu li.active").removeClass("active");
        $(".navbar").addClass("active");
    }
    function hideRightSideBar() {
        $(".navbar").removeClass("active");
    }
    function handleHamBtnClick(e) {
        e.preventDefault();
        if (hbMenuToggle) {
            hideRightSideBar();
        }
        else {
            showRightSideBar();
        }
        setRecoilHbMenuToggle(!hbMenuToggle);
        setRecoilSettingPopup(false);
        setRecoilUserInfoPopup(false);
        setRecoilAlarmPopup(false);
    }
    function onClickFuncBtn(e, type) {
        e.preventDefault();
        setRecoilHbMenuToggle(false);
        if (type === "SETTING") {
            setRecoilSettingPopup(!settingPopup); // toggle
            setRecoilUserInfoPopup(false);
            setRecoilAlarmPopup(false);
        }
        else if (type === "USER") {
            setRecoilSettingPopup(false);
            setRecoilUserInfoPopup(!userInfoPopup); // toggle
            setRecoilAlarmPopup(false);
        }
        else if (type === "ALARM") {
            setRecoilSettingPopup(false);
            setRecoilUserInfoPopup(false);
            setRecoilAlarmPopup(!alarmPopup); // toggle
        }
    }
    // header url
    function onclickHad(e, menu) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilNoneUrlInfo(false);
            e.preventDefault();
            if (menu.isExternalUrl) {
                window.open(menu.url, "_blank", "noreferrer");
                return;
            }
            var url = CUTIL.isnull(menu.url) ? CONST.URL_SYSTEM_ERROR : menu.url;
            // menu code 선택
            setRecoilMenuCode(menu.parentCode);
            const detailUserInfo = yield USERUTIL.getDetailUserInfoR(userInfo.loginInfo);
            const apiLang = CUTIL.frontLangSet(detailUserInfo.language);
            if (localStorage.getItem("langs") !== apiLang) {
                setRecoilUserInfo(Object.assign(Object.assign({}, userInfo), { language: detailUserInfo.language }));
                const params = new URLSearchParams(location.search);
                const frontLang = CUTIL.frontLangSet(detailUserInfo.language);
                const langId = CUTIL.LangIdSet(frontLang);
                localStorage.setItem("langId", langId.toString());
                yield i18n.changeLang(frontLang);
                setRecoilLangIds(langId);
                setRecoilLangs(frontLang);
            }
            setRecoilSettingPopup(false);
            setRecoilUserInfoPopup(false);
            setRecoilAlarmPopup(false);
            // Url 이동
            setRecoilTab("SITE");
            setRecoilEnergyTab(null);
            setRecoilUrlInfo(url);
            navigate(url);
        });
    }
    function MainGo(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isPSMobile) {
                const detailUserInfo = yield USERUTIL.getDetailUserInfoR(userInfo.loginInfo);
                const apiLang = CUTIL.frontLangSet(detailUserInfo.language);
                if (localStorage.getItem("langs") !== apiLang) {
                    setRecoilUserInfo(Object.assign(Object.assign({}, userInfo), { language: detailUserInfo.language }));
                    const frontLang = CUTIL.frontLangSet(detailUserInfo.language);
                    const langId = CUTIL.LangIdSet(frontLang);
                    localStorage.setItem("langId", langId.toString());
                    yield i18n.changeLang(frontLang);
                    setRecoilLangIds(langId);
                    setRecoilLangs(frontLang);
                }
                setRecoilNoneUrlInfo(false);
                if (detailUserInfo.role == CONST.USERROLE_NONE) {
                    setRecoilUrlInfo(CONST.URL_HELP);
                    navigate(CONST.URL_HELP);
                    // TODO :: 추후에 url 받는 기준으로 진입하게 수정
                    // } else if (detailUserInfo.role == CONST.USERROLE_ENGINEER) {
                    //   setRecoilUrlInfo(CONST.URL_TODAYINSPECTION);
                    //   navigate(CONST.URL_TODAYINSPECTION);
                }
                else {
                    setRecoilUrlInfo(CONST.URL_MONITORING);
                    navigate(CONST.URL_MONITORING);
                }
                setRecoilTab("SITE");
                setRecoilEnergyTab(null);
            }
        });
    }
    // 다국어 설정 변경 및 recoil 상태 변경
    function exchgLanguage(selLang, boolean) {
        return __awaiter(this, void 0, void 0, function* () {
            saveUserLangs(selLang, boolean);
        });
    }
    function saveUserLangs(frontLang, boolean) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiLang = CUTIL.apiLangSet(frontLang);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: "/user/setting/language",
                appQuery: {
                    language: apiLang,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    const frontLangs = CUTIL.frontLangSet(apiLang);
                    const langId = CUTIL.LangIdSet(frontLang);
                    yield i18n.changeLang(frontLangs);
                    setRecoilLangIds(langId);
                    setRecoilLangs(frontLangs);
                    localStorage.setItem("langId", langId.toString());
                    if (boolean) {
                        navigate(0);
                        setRecoilNoneUrlInfo(false);
                    }
                    else {
                        setRecoilNoneUrlInfo(true);
                    }
                }
                else {
                    // need error handle
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsxs("header", Object.assign({ ref: mobileRef }, { children: [_jsxs("div", Object.assign({ className: "header__left" }, { children: [_jsx("a", Object.assign({ href: "#", className: `navbar__toggleBtn ${hbMenuToggle ? "active" : ""}`, onClick: (e) => {
                                    handleHamBtnClick(e);
                                } }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC804\uCCB4\uBA54\uB274" })) })), _jsx("h1", Object.assign({ className: "header__title beyoundx", style: { cursor: !isPSMobile ? "pointer" : "" }, onClick: (e) => MainGo(e) }, { children: isPSMobile
                                    ? recoilMenuCode &&
                                        menuRecoilList
                                            .filter((smenu) => smenu.parentCode !== "MENU6" && smenu.parentCode == recoilMenuCode && smenu.url === urlInfo)
                                            .map((hmenu) => hmenu.menuName)
                                    : "Beyound X Enable" })), _jsx("ul", Object.assign({ className: "header__menu" }, { children: demos
                                    ? recoilMenuCode &&
                                        menuRecoilList
                                            .filter((smenu) => smenu.parentCode !== "MENU6" &&
                                            smenu.parentCode !== "MENU7" &&
                                            smenu.parentCode !== "MENU8" &&
                                            smenu.menuCode !== "MENU8_SUB1" &&
                                            smenu.menuName !== "운영관리" &&
                                            smenu.parentCode == recoilMenuCode)
                                            .map((hmenu, idx) => (_jsx("li", Object.assign({ className: `${hmenu.url === urlInfo ? "active" : ""}`, onClick: (e) => onclickHad(e, hmenu) }, { children: _jsx("a", Object.assign({ href: "#" }, { children: hmenu.menuName })) }), "hmenu_" + idx.toString())))
                                    : recoilMenuCode &&
                                        menuRecoilList
                                            .filter((smenu) => smenu.parentCode !== "MENU6" &&
                                            smenu.parentCode !== "MENU7" &&
                                            smenu.parentCode !== "MENU8" &&
                                            smenu.parentCode == recoilMenuCode)
                                            .map((hmenu, idx) => (_jsx("li", Object.assign({ className: `${hmenu.url === urlInfo ? "active" : ""}`, onClick: (e) => onclickHad(e, hmenu) }, { children: _jsx("a", Object.assign({ href: "#" }, { children: hmenu.menuName })) }), "hmenu_" + idx.toString()))) }))] })), _jsxs("div", Object.assign({ className: "header__right" }, { children: [_jsxs("ul", Object.assign({ className: "header__etc", style: { cursor: "default" } }, { children: [_jsx("li", { className: settingPopup ? "active" : "", style: { display: !demos ? "block" : "none" } }), _jsx("li", Object.assign({ className: alarmPopup ? "active" : "" }, { children: _jsxs("a", Object.assign({ href: "#", className: "btn btn-alarm", onClick: (e) => {
                                                onClickFuncBtn(e, "ALARM");
                                            } }, { children: [_jsx("span", Object.assign({ className: "hide" }, { children: "\uC0C8\uC54C\uB9BC" })), _jsx(AlarmCount, { alarmCountReload: alarmCountReload, setAlarmCountReload: setAlarmCountReload, setAlarmCount: setAlarmCount })] })) })), _jsx("li", Object.assign({ className: userInfoPopup ? "active" : "" }, { children: _jsx("a", Object.assign({ href: "#", className: "btn btn-admin", onClick: (e) => {
                                                onClickFuncBtn(e, "USER");
                                            } }, { children: _jsx("span", { children: userInfo.userName }) })) }))] })), _jsx("div", Object.assign({ className: "header__logo" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "LS" })) }))] })), _jsx(Setting, { settingPopup: settingPopup, exchgLanguage: exchgLanguage }), _jsx(UserInfo, { userInfoPopup: userInfoPopup }), _jsx(Alarm, { alarmPopup: alarmPopup, alarmCount: alarmCount, setAlarmCountReload: setAlarmCountReload, onClickFuncBtn: onClickFuncBtn })] })), _jsx(SideBar, { handleClick: handleHamBtnClick, isWindow: isWindow })] }));
}
export default DashBoardHeader;
function Setting(props) {
    const t = useTrans();
    const langs = useRecoilValue(langState); // recoil langState
    const { settingPopup, exchgLanguage } = props;
    return (_jsx(_Fragment, { children: _jsx("ul", Object.assign({ className: "header__setting", style: { display: settingPopup ? "" : "none", cursor: "default" } }, { children: _jsxs("li", { children: [_jsx("p", { children: t("라벨.언어") }), _jsxs("div", Object.assign({ className: "setting__btn" }, { children: [_jsx("button", Object.assign({ type: "button", className: langs == CONST.STR_LANG_KOR ? "on" : "", onClick: (e) => langs !== CONST.STR_LANG_KOR && exchgLanguage(CONST.STR_LANG_KOR, true) }, { children: _jsx("span", { children: t("라벨.한국어") }) })), _jsx("button", Object.assign({ type: "button", className: langs == CONST.STR_LANG_ENG ? "on" : "", onClick: (e) => langs !== CONST.STR_LANG_ENG && exchgLanguage(CONST.STR_LANG_ENG, true) }, { children: _jsx("span", { children: "English" }) }))] }))] }) })) }));
}
function UserInfo(props) {
    const demos = useRecoilValue(demo);
    const t = useTrans();
    const isOpen = props.userInfoPopup;
    const [alert, setAlert] = useRecoilState(alertState);
    function OpenPop(e) {
        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.체험계정입니다") }));
        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
    }
    return (_jsx(_Fragment, { children: _jsxs("ul", Object.assign({ className: "header__userinfo", style: { display: isOpen ? "" : "none", cursor: "default" } }, { children: [_jsx("li", { children: _jsx("a", Object.assign({ style: { cursor: "pointer" }, className: "js-open", "data-pop": "pop-myaccount", onClick: (e) => (demos ? OpenPop(e) : CUTIL.jsopen_Popup(e)) }, { children: "My Account" })) }), _jsx("li", { children: _jsx("a", Object.assign({ style: { cursor: "pointer" }, className: "js-open", "data-pop": "pop-logout", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: !demos ? "Logout" : t("라벨.체험종료") })) })] })) }));
}
function Alarm(props) {
    // trans, navigate
    const navigate = useNavigate();
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    const [recoilState, setRecoilState] = useRecoilState(mainState);
    const langIds = useRecoilValue(langId);
    // props
    const isOpen = props.alarmPopup;
    const alarmCount = props.alarmCount;
    const setParentAlarmCountReload = props.setAlarmCountReload;
    const onClickFuncBtn = props.onClickFuncBtn;
    const [onlyUnread, setOnlyUnread] = useState(false);
    let appPath = "";
    if (onlyUnread) {
        appPath = "?status=unread";
    }
    const [alarmList, setAlarmList] = useState([]);
    const [listReload, setListReload] = useState(false);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/notice/messages${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: isOpen + listReload + appPath + langIds,
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            if (retData.codeNum == CONST.API_200) {
                setListReload(false);
                setAlarmList(retData.body);
            }
        }
    }, [retData, langIds]);
    function onClickDoToggleReadYn(e, alarm) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/notice/isread`,
                appQuery: {
                    noticeId: alarm.noticeId,
                    readYN: alarm.readYN ? false : true,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setParentAlarmCountReload(true);
                    setListReload(true);
                }
                else {
                }
            }
        });
    }
    function onClickDoToggleGotonReadYn(e, alarm) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            let data = null;
            if (!alarm.readYN) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/notice/isread`,
                    appQuery: {
                        noticeId: alarm.noticeId,
                        readYN: !alarm.readYN,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setParentAlarmCountReload(true);
                    }
                    else {
                        setListReload(true);
                    }
                }
            }
            setRecoilState({
                companyId: alarm.companyId ? alarm.companyId : recoilState.companyId,
                zoneId: alarm.zoneId ? alarm.zoneId : alarm.companyId && alarm.zoneId ? "" : recoilState.zoneId,
            });
            onClickFuncBtn(e, "ALARM");
            setRecoilNoneUrlInfo(false);
            setRecoilUrlInfo(alarm.link);
            navigate(alarm.link);
        });
    }
    function onClickDoAllRead(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/notice/allread`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    setParentAlarmCountReload(true);
                    setListReload(true);
                }
                else {
                }
            }
        });
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "header__alarm", style: { display: isOpen ? "" : "none", cursor: "default" } }, { children: [_jsxs("div", Object.assign({ className: "alarm__top" }, { children: [_jsxs("p", Object.assign({ className: "title" }, { children: ["Alarm", _jsxs("span", Object.assign({ className: "num" }, { children: [alarmList.length, " ", t("라벨.건")] }))] })), _jsx("button", Object.assign({ type: "button", onClick: (e) => setOnlyUnread(!onlyUnread) }, { children: _jsx("span", { children: onlyUnread ? t("라벨.전체알림표시") : t("라벨.안읽은알림만표시") }) }))] })), alarmList.length <= 0 ? (_jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.지난30일동안받은알림이없음") }))) : (_jsxs("div", Object.assign({ className: "alarm__notice" }, { children: [_jsx("p", { children: t("라벨.최신") }), _jsx("button", Object.assign({ type: "button", className: `btn-alarmread ${alarmCount <= 0 ? "hidden" : ""}`, onClick: (e) => onClickDoAllRead(e) }, { children: _jsx("span", { children: t("라벨.모두읽음") }) }))] }))), alarmList.length > 0 && (_jsx("ul", Object.assign({ className: "alarm__list" }, { children: alarmList.map((alarm, idx) => (_jsx("li", { children: _jsxs("a", Object.assign({ onClick: (e) => onClickDoToggleGotonReadYn(e, alarm) }, { children: [_jsxs("div", Object.assign({ className: "list__name" }, { children: [_jsx("p", { children: alarm.message }), _jsx("button", Object.assign({ type: "button", className: alarm.readYN ? "readend" : "", onClick: (e) => onClickDoToggleReadYn(e, alarm) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0C8\uC54C\uB78C" })) }))] })), _jsxs("div", Object.assign({ className: "list__info" }, { children: [_jsx("p", Object.assign({ className: "list__txt" }, { children: _jsxs("span", Object.assign({ className: "tooltip" }, { children: [alarm.subMessage, _jsx("span", Object.assign({ className: "tooltip-text" }, { children: alarm.subMessage }))] })) })), _jsx("p", Object.assign({ className: "time" }, { children: CUTIL.utc2formedstr(alarm.createdTime, "yy-MM-DD hh:mm:ss") }))] }))] })) }, `li_${idx.toString()}`))) }))), alarmList.length > 0 && _jsx("p", Object.assign({ className: "alarm__end" }, { children: t("라벨.지난30일동안받은모든알람은여기까지입니다") }))] })) }));
}
